import moment from 'moment-timezone';
import { useFormContext } from 'react-hook-form';
import { removeHtmlTagsFromString, sortNumberArray } from 'utilitys/helpers/general';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';
import { useQueryGetRiskRegisterAuditLog } from 'api/queries/getRiskRegisterAuditLog.query';

import constants from 'components/common/Constants/constants';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { ProfileImage } from 'components/common/ProfileImage/profileImage';

import { ContentText } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/activityLog/contentText/contentText';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/AuditLog/AuditLog.module.scss';

export const AuditLog = () => {
    const { watch } = useFormContext<Risk>();
    const { data, isLoading } = useQueryGetRiskRegisterAuditLog({ riskId: watch('id') });

    return (
        <div data-testid={'activity-log-container'} className={classes.activityLogContainer}>
            {isLoading && <OverlayWithSpinner />}
            {data &&
                data.map((item, index) => {
                    const content = {
                        changeDate: item.changeDate,
                        fieldName: item.attributeName,
                        firstName: item.changedBy.firstName,
                        lastName: item.changedBy.lastName,
                        newValues: removeHtmlTagsFromString(item.newValue),
                        oldValues: item.oldValue ? removeHtmlTagsFromString(item.oldValue) : 'N/A',
                        revision: item.changeDate,
                        userName: item.changedBy.userName,
                        userChanger: item.changedBy,
                    };
                    return (
                        <div className={classes.logWrapper} key={`${item.changeDate}-${index}`}>
                            <ProfileImage
                                fullName={`${item.changedBy?.firstName} ${item.changedBy?.lastName}`}
                                email={item.changedBy?.userName}
                                imageName={item.changedBy?.imageName || ''}
                                isUnassigned={false}
                            />
                            <div data-testid={'activity-log-content'} className={classes.content}>
                                <div className={classes.textContent}>
                                    <ContentText log={content} />
                                </div>
                                <div data-testid={'activity-log-date'} className={classes.date}>
                                    {moment(item.changeDate).format(constants.formats.date.fullDateWithMilliSeconds)}
                                </div>
                            </div>
                        </div>
                    );
                })}

            {!isLoading && data && data.length === 0 && <div className={classes.NoChange}>No changes yet</div>}
        </div>
    );
};
